import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import { MonthHeader as MonthHeader$2, WeekNrCell, DayNameCell } from './style.js';
import { weekPrefix, dayNames, dayShortNames } from './texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MonthHeader = function MonthHeader(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var days = dayShortNames[culture];
  return /*#__PURE__*/jsxs(MonthHeader$2, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/jsx(WeekNrCell, {
      children: weekPrefix[culture]
    }, "day-week-prefix"), days.map(function (day, index) {
      return /*#__PURE__*/jsx(DayNameCell, {
        title: dayNames[culture][index],
        children: day
      }, "day-".concat(day));
    })]
  }));
};
var MonthHeader$1 = MonthHeader;

export { MonthHeader$1 as default };
//# sourceMappingURL=MonthHeader.js.map
